import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';

import {
  ConditionGraduation,
  ConditionGraduationLevel,
} from '@mp/contract-management/condition-details/tab-graduations/domain';

import { ConditionInfoSectionComponent } from '../../condition-info-section/condition-info-section.component';

import { ConditionGraduationsComponent } from './condition-graduations/condition-graduations.component';

@Component({
  selector: 'mpctm-condition-graduations-section',
  templateUrl: './condition-graduations-section.component.html',
  styleUrl: './condition-graduations-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConditionInfoSectionComponent, ConditionGraduationsComponent],
})
export class ConditionGraduationsSectionComponent {
  readonly conditionGraduations: InputSignal<ConditionGraduation[] | null> = input.required<
    ConditionGraduation[] | null
  >();

  readonly conditionSelectionCount: InputSignal<number> = input.required<number>();

  readonly baseConditionName: InputSignal<string | null> = input.required<string | null>();
  readonly baseCondition: InputSignal<ConditionGraduationLevel | null> =
    input.required<ConditionGraduationLevel | null>();
}
